import React from 'react';
import { assetUrl } from '~/helpers';

export enum ImageType {
  Square = 'square',
  Circle = 'circle',
}

export interface ImageProps {
  imageType: ImageType;
  imageUrl?: string;
}

export default function Image({ imageType, imageUrl }: ImageProps) {
  switch (imageType) {
    case ImageType.Circle:
      return (
        <img
          className='min-w-full min-h-full object-cover'
          src={imageUrl ?? assetUrl('assets/images/icons/profile.png')}
        />
      );
    case ImageType.Square:
      return imageUrl ? (
        <img className='max-w-full max-h-full' src={imageUrl} />
      ) : (
        <i className='fas fa-image fa-2x text-neutral' />
      );
  }
}
